import { render, staticRenderFns } from "./classifySelectV2.vue?vue&type=template&id=6a094df0&scoped=true"
import script from "./classifySelectV2.vue?vue&type=script&lang=js"
export * from "./classifySelectV2.vue?vue&type=script&lang=js"
import style0 from "./classifySelectV2.vue?vue&type=style&index=0&id=6a094df0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a094df0",
  null
  
)

export default component.exports